import { createContext } from "@design-system/react-utils"
import { PortalContext } from "./types"

const [PortalContextProvider, usePortalContext] = createContext<PortalContext>({
  strict: false,
  name: "PortalContext",
})

export { PortalContextProvider, usePortalContext }
